import { createFileRoute } from "@tanstack/react-router";
import Page from "@/app/auth/register/dearest/page";

export const Route = createFileRoute("/auth/register/dearest")({
  component: Page,
});
